import "./infiniteProgressBar.css"

export const InfiniteProgressBar = () => {
  return (<div className="indeterminate-progress-bar h-2">
      <div className="indeterminate-progress-bar__progress bg-brandPrimary dark:bg-primary-600"></div>
  </div>)
}
